'use strict';

import listService from 'ListService.js';
import constants from 'Constants.js';
import themeService     from 'ThemeService.js';
import formModel     from 'formModel.js';
import eventBus from 'EventBus.js';

//====================================================================================================
// A singleton instance of this class exposes functionality for handle zoom on different components.
// Rene Lopez.
// March 28th 2016
//====================================================================================================
class ZoomService {

    /*====================================================================================================*/
    // Method that zooms in or zooms out the displayed canvas on the page, according to given scale factor.
    /*====================================================================================================*/

    // PF-3527 Commented as it will be used on next versions.
    /*
    handleCanvasZoom(scaleFactor) {

        let currentForm=listService.currentForm;
        let currentFormGridWidthWithScaleFactor=currentForm.model.get('gridWidth') * scaleFactor;
        let currentFormGridHeightWithScaleFactor=currentForm.model.get('gridHeight') * scaleFactor;

        // Retrieving required values for zooming the canvas.
        let values = {
            width: $(constants.PAGE_ID).width() * scaleFactor, // Scaled Page Width.
            height: $(listService.currentForm.canvasId).height() * scaleFactor,// Scaled Canvas Height.
            gridWidth: currentFormGridWidthWithScaleFactor, // Scaled Grid Width.
            gridHeight: currentFormGridHeightWithScaleFactor   // Scaled Grid Height.
        }


        // Doing specific functionality if the Zoom requested was in or out.
        if(scaleFactor === constants.SCALE_FACTOR_ZOOM_IN) {
            this.resizeCanvas(values.width, values.height, values.gridWidth, values.gridHeight,true);
        }
        else{
            this.resizeCanvas(values.width, values.height, values.gridWidth, values.gridHeight,false);
        }

        // Scaling the canvas at the end so that the grid can be rendered on the canvas with the previous scale.

        $(constants.PAGE_ID).find('canvas')[0].getContext('2d').scale(scaleFactor, scaleFactor);
        $(listService.currentForm.canvasId).get(0).getContext('2d').scale(scaleFactor, scaleFactor);
        eventBus.trigger('gridWidthSet',currentFormGridWidthWithScaleFactor);
        eventBus.trigger('gridHeightSet',currentFormGridHeightWithScaleFactor);
    }

    handleCanvasSingleZoom(scaleFactor,type){

        let values={};
        switch (type){
            case 'height':
                values = {
                width: $(constants.PAGE_ID).width() * scaleFactor, // Scaled Page Width.
                height: $(constants.PAGE_ID).height() * scaleFactor,// Scaled Canvas Height.
                gridWidth: listService.currentForm.model.attributes.gridWidth * scaleFactor, // Scaled Grid Width.
                gridHeight: listService.currentForm.model.attributes.gridHeight * scaleFactor   // Scaled Grid Height.
            };break;
            case 'width':
                values = {
                    width: $(constants.PAGE_ID).width() * scaleFactor, // Scaled Page Width.
                    height: $(constants.PAGE_ID).height() * scaleFactor,// Scaled Canvas Height.
                    gridWidth: listService.currentForm.model.attributes.gridWidth * scaleFactor, // Scaled Grid Width.
                    gridHeight: listService.currentForm.model.attributes.gridHeight * scaleFactor   // Scaled Grid Height.
                };break;
        }

        // Doing specific functionality if the Zoom requested was in or out.
        this.resizeCanvas(values.width, values.height, values.gridWidth, values.gridHeight,false);


        // Scaling the canvas at the end so that the grid can be rendered on the canvas with the previous scale.
        $(constants.PAGE_ID).get(0).getContext('2d').scale(scaleFactor, scaleFactor);
        $(listService.currentForm.canvasId).get(0).getContext('2d').scale(scaleFactor, scaleFactor);
    }


    handleFitToWindow(){
        console.log('Form Size',formModel.attributes.currentDevice);
        console.log("Current height",listService.currentForm);
        console.log("Current width",listService.currentForm);
        let editorElement=$(".editor-pane");
        let scaleToApply;
        if(listService.currentForm.model.attributes.formHeight > listService.currentForm.model.attributes.formWidth){
            // Decrease height only.
            let editorHeight=editorElement.height();
            scaleToApply=editorHeight / listService.currentForm.model.attributes.formHeight;
            if(editorHeight > listService.currentForm.model.attributes.formHeight){
                while ($(constants.PAGE_ID).height() < editorHeight) {
                    this.handleAllControlsZoom(scaleToApply);
                    this.handleCanvasSingleZoom(scaleToApply, 'height');
                }
            }
            else if(editorHeight < listService.currentForm.model.attributes.formHeight){
                while ($(constants.PAGE_ID).height() > editorHeight) {
                    this.handleAllControlsZoom(scaleToApply);
                    this.handleCanvasSingleZoom(scaleToApply, 'height');
                }
            }
        }
        else if(listService.currentForm.model.attributes.formHeight  < listService.currentForm.model.attributes.formWidth) {
            // Decrease Width Only
            let editorWidth=editorElement.width();
            scaleToApply=editorWidth / listService.currentForm.model.attributes.formWidth;
            if(editorWidth > listService.currentForm.model.attributes.formWidth){
                while ($(constants.PAGE_ID).width() < editorWidth) {
                    this.handleAllControlsZoom(scaleToApply);
                    this.handleCanvasSingleZoom(scaleToApply, 'width');
                }
            }
            else if(editorWidth < listService.currentForm.model.attributes.formWidth){
                while ($(constants.PAGE_ID).width() > editorWidth) {
                    this.handleAllControlsZoom(scaleToApply);
                    this.handleCanvasSingleZoom(scaleToApply, 'width');
                }
            }
        }
    }
    */

    /*====================================================================================================*/
    // Method that zooms in or zooms out the current controls on the page, according to given scale factor.
    /*====================================================================================================*/
    /* PF-3527 Commented as it will be used on next versions.
    handleAllControlsZoom(scaleFactor) {
        let isInvalidZoom=false;   // Validating first if the zoom can be performed on both IN and OUT.
        if(scaleFactor === constants.SCALE_FACTOR_ZOOM_IN) {
           isInvalidZoom=this.isInvalidControlZoomIn(scaleFactor);
        }
        else{
            isInvalidZoom=this.isInvalidControlZoomOut(scaleFactor);
        }

        // Checks Zoom constraint so it cant zoom anymore.
        if (isInvalidZoom) {
            return false
        }
        // If zoom can be performed, loop all the controls and resize them, by first resizing the parent and after its children.
        listService.getPageControls(listService.currentPageId).map(view => {
            const domId = view.id;
            let that = this;
            let parentControl = $(`${constants.ID_SEL}${domId}`);
            this.zoomControl(parentControl, scaleFactor, true);
            let clientControls = parentControl.children();
            clientControls.each(function () {
                that.zoomControl(this, scaleFactor, false);
            });
        });
        
        return true;
    }
    */

    /*====================================================================================================*/
    // Method that zooms in or zooms out an specific control on the page, according to given scale factor.
    /*====================================================================================================*/
    /* PF-3527 Commented as it will be used on next versions.
    handleSpecificControlZoom(scaleFactor,controlId) {

        // If zoom can be performed, loop all the controls and resize them, by first resizing the parent and after its children.
            let parentControl = $(`${constants.ID_SEL}${controlId}`);
            let clientControls = parentControl.children();
            let that=this;
            clientControls.each(function () {
                that.zoomSpecificControl(this, scaleFactor);
            });
    }
    /*

    /*======================================================================================*/
    // Method that checks if a Control can be zoomed in by calculating first the future
    // value that it would take if zoomed in against the MAX SIZE of the form.
    /*======================================================================================*/
    /* PF-3527 Commented as it will be used on next versions.
    isInvalidControlZoomIn(scaleFactor){
        let isInvalid = listService.getPageControls(listService.currentPageId).some(view => {
            const domId = view.id;
            let currentControl = $(`${constants.ID_SEL}${domId}`);
            let parentControlPosition = currentControl.position();
            let newX = (parentControlPosition.left * scaleFactor) + (currentControl.width() * scaleFactor);
            let newY = (parentControlPosition.top * scaleFactor) + (currentControl.height() * scaleFactor);
            let currentForm = $(constants.FORM_ID);
            return (newX >= currentForm.width() || newY >= currentForm.height());
        });
        return isInvalid;
    }
    */

    /*======================================================================================*/
    // Method that checks if a Control can be zoomed out.
    /*======================================================================================*/
    /* PF-3527 Commented as it will be used on next versions.
    isInvalidControlZoomOut(scaleFactor){
        // TODO Validate zoom out. Right now it zooms out until the canvas is on the original size.
        return false;
        // const currentCanvas=$(listService.currentForm.canvasId);
        // console.log("current canvas is",currentCanvas);
        // switch(listService.currentForm.model.attributes.currentLayout){
        //     case 'desktopLayout':  validateZoom = (currentCanvas.width() === parseInt(constants.DESKTOP_MAX_WIDTH) && currentCanvas.height() === parseInt(constants.DESKTOP_MAX_HEIGHT));
        //         break;
        //     case 'tabletLayout': validateZoom = (currentCanvas.width() === parseInt(constants.TABLET_MAX_WIDTH) && currentCanvas.height() === parseInt(constants.TABLET_MAX_HEIGHT));
        //         break;
        //     case 'phoneLayout': validateZoom = (currentCanvas.width() === parseInt(constants.PHONE_MAX_WIDTH) && currentCanvas.height() === parseInt(constants.PHONE_MAX_HEIGHT));
        //         break;
        // }
    }
    */

    /*======================================================================================*/
    // Method that zooms an specific control by resizing each one of its internal components accordingly.
    /*======================================================================================*/
    /* PF-3527 Commented as it will be used on next versions.
    zoomControl(elem, scaleFactor, isParent) {

        let control = $(elem);
        let position = control.position();
        if (isParent) { //If its the parent, just resize its top and left positions.
             control.css({
                 left: position.left * scaleFactor,
                 top: position.top * scaleFactor
            });

        }

        // If its one of their children,resize depending on which child control is.
        else if (control.hasClass('size-handle-top')) {
            control.width((control.width() - constants.ACCUM_BRACKETED_BORDER_WIDTH) * scaleFactor);
        }
        else if (control.hasClass('size-handle-left')) {
            control.height((control.height() - constants.ACCUM_BRACKETED_BORDER_WIDTH) * scaleFactor);
        }
        else if (control.hasClass('pf-control-core')) {
            control.height((control.height()) * scaleFactor);
            control.width((control.width()) * scaleFactor);
            control.css({'font-size': (parseFloat(control.css('font-size')) * scaleFactor) + 'px'})
        }
        else if (control.hasClass('size-handle-right')) {
            control.height((control.height() - constants.ACCUM_BRACKETED_BORDER_WIDTH) * scaleFactor);
        }
        else {
            control.width((control.width() - constants.ACCUM_BRACKETED_BORDER_WIDTH) * scaleFactor);
        }
    }

    fillZoomScaleAttribute(scaleFactor){
        if(!listService.currentForm.model.attributes.zoomScale){
            listService.currentForm.model.attributes.zoomScale=scaleFactor;
        }else{
            listService.currentForm.model.attributes.zoomScale=listService.currentForm.model.attributes.zoomScale * scaleFactor;
        }
    }
    */
    /*======================================================================================*/
    // Method that zooms an specific control by resizing only the control inside of it.
    /*======================================================================================*/
    /* PF-3527 Commented as it will be used on next versions.
    zoomSpecificControl(elem, scaleFactor) {

        let control = $(elem);
        if (control.hasClass('pf-control-core')) {
            control.height((control.height()) * scaleFactor);
            control.width((control.width()) * scaleFactor);
            control.css({'font-size': (parseFloat(control.css('font-size')) * scaleFactor) + 'px'})
        }
    }
    */

    /*======================================================================================*/
    // Method that resize the canvas without modifying the underneath Backbone Model.
    /*======================================================================================*/
    /*
    resizeCanvas(width, height, gridWidth, gridHeight,isIncreasing) {
        let $formElement = $(constants.FORM_ID);
        let newWidth,newHeight;

        // Validating that the increased size of the canvas is not more than the max form size allowed.If it is leave the max.
        if(isIncreasing){
            newWidth = width > $formElement.width() ? $formElement.width() : width;
            newHeight = height > $formElement.height() ? $formElement.height() : height;
        }
        // Validating that the decreasing size is not less that the original value of the canvas, according to the current layout being displayed.
        else{
            switch(listService.currentForm.model.attributes.currentLayout){
                case 'desktopLayout': newWidth = width < constants.DESKTOP_MAX_WIDTH ? constants.DESKTOP_MAX_WIDTH: width;
                                      newHeight = height < constants.DESKTOP_MAX_HEIGHT ? constants.DESKTOP_MAX_HEIGHT: height;
                                      break;
                case 'tabletLayout': newWidth = width < constants.TABLET_MAX_WIDTH ? constants.TABLET_MAX_WIDTH: width;
                    newHeight = height < constants.TABLET_MAX_HEIGHT ? constants.TABLET_MAX_HEIGHT: height;
                    break;
                case 'phoneLayout': newWidth = width < constants.PHONE_MAX_WIDTH ? constants.PHONE_MAX_WIDTH: width;
                    newHeight = height < constants.PHONE_MAX_HEIGHT ? constants.PHONE_MAX_HEIGHT: height;
                    break;
            }
        }


        // Performing the render of the GRID,taken from the PageView.js Backbone View.
        const $canvasPage = $(constants.PAGE_ID);
        const canvasPageContext = $canvasPage.find('canvas')[0].getContext("2d");

        const $canvasPageSel = $(listService.currentForm.canvasId);
        const canvasPageSelContext = $canvasPageSel.get(0).getContext("2d");

        const formSize = {
            width: newWidth,
            height: newHeight
        };
        const gridSize = {
            width: gridWidth,
            height: gridHeight
        };

        // Draw the page background canvas atop the shadow, but not offset.
        $canvasPage.css({'left': 0, 'top': 0, 'position': 'absolute', 'border': 'solid 1px #b8b8b8'});
        $canvasPage.attr(formSize);

        // Draw a page multi-select canvas atop the canvas 1:1, but transparent.
        $canvasPageSel.css({'left': 0, 'top': 0, 'position': 'absolute'});
        $canvasPageSel.attr(formSize);

        //ctx.scale(scaleFactor, scaleFactor);

        // Draw visible  page
        canvasPageContext.fillStyle = themeService.resolve(listService.currentForm.model.attributes.pageColor);
        canvasPageContext.fillRect(0, 0, formSize.width, formSize.height);

        //ctx2.scale(scaleFactor, scaleFactor);

        // Draw invisible multiselection layer
        // It will have attached drag-drop listeners.
        canvasPageSelContext.fillStyle = 'rgba(0, 0, 0, 0.0)';
        canvasPageSelContext.fillRect(0, 0, formSize.width, formSize.height);


        canvasPageContext.strokeStyle = '#dcdcdc';
        canvasPageContext.lineWidth = 0.9;
        canvasPageContext.strokeRect(1, 1, formSize.width - 2, formSize.height - 1);

        if (gridSize.width > 0) {
            for (let x = gridSize.width; x < formSize.width; x += gridSize.width) {
                canvasPageContext.moveTo(x, 0);
                canvasPageContext.lineTo(x, formSize.height);
                canvasPageContext.stroke();
            }
        }

        if (gridSize.height > 0) {
            for (let y = gridSize.height; y < formSize.height; y += gridSize.height) {
                canvasPageContext.moveTo(0, y);
                canvasPageContext.lineTo(formSize.width, y);
                canvasPageContext.stroke();
            }
        }
        canvasPageSelContext.fillRect(0, 0, formSize.width, formSize.height);
    }
    */
}



const zoomService = new ZoomService();
export default zoomService;

